module.exports = __webpack_public_path__ + "media/images/indicators/balanco-03f322bc2197f74d63f354cdeddb30eb.png";